import { useState } from "react";

export default function useForceUpdate(): [unknown, () => void] {
    const [value, setValue] = useState<number>(0);
    return [value, () => setValue(value => value + 1)]; // update state to force render
}